import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col
} from 'reactstrap';
import logo from '../../../Assets/Images/logo.png';
import doublearrow from '../../../Assets/Images/double-arrow.png';
import { useForm, Controller } from "react-hook-form";
import { useLocation } from "react-router-dom";
import '../../../Assets/icon-fonts/icons.css';
import MenuItem from "@mui/material/MenuItem";
import { IconButton, ListItemIcon, Menu } from '@mui/material';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import HubspotForm from 'react-hubspot-form'
import { Config } from '../../../Utils/Config';
import { useNavigate } from 'react-router-dom';
import Logout from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useDispatch } from 'react-redux';

const DefaultLayout = () => {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openUserMenu = Boolean(anchorEl);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isPaymentSuccesScreen = pathname.includes(
    "/add-market-payment-success/"
  );
  var userDetails =
    localStorage.getItem("user") !== null ? localStorage.getItem("user") : null;
  var username =
    userDetails !== null && JSON.parse(userDetails).username !== null
      ? JSON.parse(userDetails).username
      : "";
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggle = (value) => {
    setOpen(!value);
  }
  const navigate = useNavigate();
  const handleClick = () => {
    dispatch({ type: 'developmentFilters', value: [] });
    navigate('/preview-market'); // Replace with your target page route
  };
   const handleLogout = () => {
     localStorage.removeItem("user");
     localStorage.clear();
     navigate("/");
  }; 

  const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};

  return (
    <div>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openUserMenu}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0
            }
          }
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        className="top-logout sign-links"
      >{
        isPaymentSuccesScreen ? (
          <MenuItem onClick={() => {handleClose();handleLogout()}}>
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        ) : (
          <>
            <MenuItem>
          <a href={Config.ListRVSignInUrl+"/signin"}><PersonRoundedIcon /> Broker Login / Submit A Property</a>
        </MenuItem>
        <MenuItem>
          <Link to={"/signin"}><PersonRoundedIcon /> Explorer Login</Link>
        </MenuItem></>
      )}
      
      </Menu>
      <Navbar
        container="md"
        expand="md"
        light
        className='navbar-top menubg p-3'
      >
        <NavbarBrand href={Config.ListRVSignInUrl+"/"}>
          <img src={logo} alt="RVParkIQ" />
        </NavbarBrand>
        <NavbarToggler onClick={()=> toggle(open)} />
        <Collapse navbar isOpen={open}>
          <Nav
            className="me-auto main-menu"
            navbar
          >
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/"}>
                Home
              </NavLink>
            </NavItem>
            <NavItem>
              <Link to={"/market-data"} className='headeractive nav-link'>
                Market Data
              </Link>
            </NavItem>
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/listings"}>
                Listings
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/vendors"}>
                Vendors
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/industry-insights"}>
                Industry Insights
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/user/addproperty"}>
                Submit Property
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href={Config.ListRVSignInUrl+"/aboutus"}>
                About Us
              </NavLink>
            </NavItem>
            <li className='nav-item preview-market_nav'>
              <button onClick={handleClick} className="preview-market-btn">
                <img src={doublearrow} />
                Preview a Market                
              </button>
            </li>
            <li className='nav-item'>
                 {isPaymentSuccesScreen ? (
                <div className="user-profile" style={{ marginTop: "-12px" }}>
                  <span className="welcome-user">
                    <b>{username}</b>
                  </span>
                  <IconButton onClick={handleOpen} className="ps-0 welcome-btn">
                    <AccountCircleIcon />
                    <ArrowDropDownIcon />
                  </IconButton>
                </div>
              ) : (
              <button onClick={handleOpen} className="login-signup">Log In / Sign Up
                <svg inert="true" focusable="false" data-prefix="fas" data-icon="sign-in-alt" className="svg-inline--fa fa-sign-in-alt fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"></path></svg>
              </button>)}
            </li>
          </Nav>
        </Collapse>
      </Navbar>

      <Outlet />
      <div className='footer-section'>        
        <div className='footer'>
        <div className='newsletter'>
          <Container>
            <Row>
              <Col>
                <h2>Subscribe to our newsletter</h2>
                <p>Stay up-to-date on new listings, industry news, market insights, interviews and more!</p>
                <div className="reactHubspotForms">
                  <HubspotForm
                    portalId='4297816'
                    formId='ba6678dc-56ea-4dc7-9def-bcc48cf8aca8'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
          <Container>
            <Row>
              <Col md={4} className="footer-contact-us">
                <h4>Contact us</h4>
                <div className='leftColor-separator-small'></div>
                <div className="list">
                  <div className="list-item address-col">
                    <svg inert="true" focusable="false" data-prefix="fas" data-icon="location-dot" className="svg-inline--fa fa-location-dot " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z"></path></svg>
                    <div className="list-content">26400 Lahser Rd. Suite 210<br />Southfield, MI 48033</div>
                  </div>
                  <div className="list-item">
                    <svg inert="true" focusable="false" data-prefix="fas" data-icon="envelope" className="svg-inline--fa fa-envelope " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M464 64C490.5 64 512 85.49 512 112C512 127.1 504.9 141.3 492.8 150.4L275.2 313.6C263.8 322.1 248.2 322.1 236.8 313.6L19.2 150.4C7.113 141.3 0 127.1 0 112C0 85.49 21.49 64 48 64H464zM217.6 339.2C240.4 356.3 271.6 356.3 294.4 339.2L512 176V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V176L217.6 339.2z"></path></svg>
                    <div className="list-content">
                      <a href={'mailto:'+Config.supportEmail}>{Config.supportEmail}</a>
                    </div>
                  </div>
                  <div className="list-item">
                    <svg inert="true" focusable="false" data-prefix="fas" data-icon="phone" className="svg-inline--fa fa-phone " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M511.2 387l-23.25 100.8c-3.266 14.25-15.79 24.22-30.46 24.22C205.2 512 0 306.8 0 54.5c0-14.66 9.969-27.2 24.22-30.45l100.8-23.25C139.7-2.602 154.7 5.018 160.8 18.92l46.52 108.5c5.438 12.78 1.77 27.67-8.98 36.45L144.5 207.1c33.98 69.22 90.26 125.5 159.5 159.5l44.08-53.8c8.688-10.78 23.69-14.51 36.47-8.975l108.5 46.51C506.1 357.2 514.6 372.4 511.2 387z"></path></svg>
                    <div className="list-content">
                      <a href={'tel:'+Config.PhoneNumber}>{Config.PhoneNumber}</a>
                    </div>
                  </div>
                  <div className="socialicon">
                    <a href="https://www.linkedin.com/company/rv-park-iq/" target="blank" rel="noopener noreferrer">
                      <svg inert="true" focusable="false" data-prefix="fab" data-icon="linkedin" className="svg-inline--fa fa-linkedin " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
                    </a>
                    <a href="https://twitter.com/rvparkiq" target="blank" rel="noopener noreferrer">
                      <svg inert="true" focusable="false" data-prefix="fab" data-icon="twitter" className="svg-inline--fa fa-twitter " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M459.4 151.7c.325 4.548 .325 9.097 .325 13.65 0 138.7-105.6 298.6-298.6 298.6-59.45 0-114.7-17.22-161.1-47.11 8.447 .974 16.57 1.299 25.34 1.299 49.06 0 94.21-16.57 130.3-44.83-46.13-.975-84.79-31.19-98.11-72.77 6.498 .974 12.99 1.624 19.82 1.624 9.421 0 18.84-1.3 27.61-3.573-48.08-9.747-84.14-51.98-84.14-102.1v-1.299c13.97 7.797 30.21 12.67 47.43 13.32-28.26-18.84-46.78-51.01-46.78-87.39 0-19.49 5.197-37.36 14.29-52.95 51.65 63.67 129.3 105.3 216.4 109.8-1.624-7.797-2.599-15.92-2.599-24.04 0-57.83 46.78-104.9 104.9-104.9 30.21 0 57.5 12.67 76.67 33.14 23.72-4.548 46.46-13.32 66.6-25.34-7.798 24.37-24.37 44.83-46.13 57.83 21.12-2.273 41.58-8.122 60.43-16.24-14.29 20.79-32.16 39.31-52.63 54.25z"></path></svg>
                    </a>
                    <a href="https://www.facebook.com/RV-Park-IQ-113812351310680/" target="blank" rel="noopener noreferrer">
                      <svg inert="true" focusable="false" data-prefix="fab" data-icon="facebook-square" className="svg-inline--fa fa-facebook-square " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.3V327.7h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0 -48-48z"></path></svg>
                    </a>

                  </div>
                </div>
              </Col>
              <Col md={4}>
                <h4>Quick Links</h4>
                <div className='leftColor-separator-small'></div>
                <div className="list quicklinks">
                  <ul>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/"}>Home</a>
                    </li>
                    <li>
                      <Link to={"/market-data"}>Market Data</Link>
                    </li>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/listings"}>Listings</a>
                    </li>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/vendors"}>Vendors</a>
                    </li>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/industry-insights/"} rel="noreferrer">Industry Insights</a>
                    </li>
                    <li>
                      <a href={Config.ContactUrl}>Contact</a>
                    </li>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/user/addproperty"}>Submit Property</a>
                    </li>
                    <li>
                      <a href={Config.ListRVSignInUrl+"/aboutus"}>About Us</a>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col md={4}>
                <h4>New Properties</h4>
                <div className='leftColor-separator-small'></div>
              </Col>
            </Row>
          </Container>
          <div className='copy-rights'>
            <Container>
              <Row>
            <Col md={6}><p style={{textAlign: 'left'}}>Copyright ©{(new Date().getFullYear())} StorTrack, Inc. All Rights Reserved.</p></Col>
            <Col md={6}><p style={{textAlign: 'right'}}><Link to={"/privacy-policy"} onClick={() => scrollToTop()} style={{color: '#fff'}} className='privacy-link'>Privacy Policy</Link>
            <span style={{marginLeft: '5px', marginRight: '5px'}}>|</span>
            <Link to={"/terms-of-service"} onClick={() => scrollToTop()} style={{color: '#fff'}} className='privacy-link'>Terms of Service</Link>
            </p></Col>
            </Row>
            </Container>
          </div>

        </div>
      </div>
    </div>

  );
}

export default DefaultLayout;